export const MODAL_TITLE = 'Emergency Brake Assist';
